import React from 'react';
import { VariantCard } from '@qover/organisms';
import { DiscountCode } from '@qover-private/protos-web/qover/dojo/contracts/v1/contract';
import messages from './bikeVariantCard.messages';
import {
  Description,
  Price,
  DiscountPrice,
  InnerContainer,
  DiscountContainer,
  VariantTitle,
} from './bikeVariantCard.styles';

type BikeVariantCardProps = React.PropsWithChildren<{
  banner?: JSX.Element;
  dirty: boolean;
  discount: number;
  discountCode?: DiscountCode;
  discountPrice: number;
  'data-test': string;
  title: JSX.Element | null;
  price?: number;
  onClick: React.DOMAttributes<HTMLButtonElement>['onClick'];
}>;

export const BikeVariantCard = (props: BikeVariantCardProps) => {
  return (
    <VariantCard
      badge={
        props.discountCode && !!props.price
          ? messages.discount(props.discount)
          : undefined
      }
      banner={props.banner}
      containerClassName="grow"
      data-test={props['data-test']}
      justify
      onClick={props.onClick}
      showAction={!!props.price && !props.dirty}
      small
      // @ts-ignore
      renderHeading={VariantTitle}
      title={props.title}
      type="button"
    >
      {!props.dirty && !!props.price && !props.discountCode && (
        <div className="animated fadeIn">
          <Price>{messages.price(props.price)}</Price>
          <Description>{messages.description}</Description>
        </div>
      )}
      {!props.dirty && !!props.price && !!props.discountCode && (
        <div className="animated fadeIn">
          <DiscountContainer>
            <Price className="small">{messages.price(props.price)}</Price>
            &nbsp;
            <DiscountPrice>
              {messages.discountPrice(props.discountPrice)}
            </DiscountPrice>
          </DiscountContainer>
          <Description>
            {props.discountCode.isRecurring
              ? messages.description
              : messages.recurringDescription}
          </Description>
        </div>
      )}
      <InnerContainer className={props.price ? '' : 'small'}>
        {props.children}
      </InnerContainer>
    </VariantCard>
  );
};
